import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import MediaQuery from 'react-responsive';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton';
import { stat } from 'fs';
import './PokerwatchFilter.css'
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';

var _ = require('lodash');
class PokerwatchFilters extends React.Component {
    constructor(props){
        super(props)
        this.state={
            access: JSON.parse(localStorage.getItem('userRole')),
            msg:'',
            open: false,
            openSearch:false,
            fromDate:props.fromDate,
            toDate:props.toDate,
            shiftValue:props.shiftValue,
            timeValue:props.timeValue ,   
            nightShift:false,
            shiftValue:props.shiftValue,
            timeValue:'Select',
            timeZonevalue:'Select',
            alias:'',
            timeZone:moment.tz.guess(),
            loginRedirect: false,
            nightShift:false,
            shift:"Select",
            selectAllPlayer:true,
            fTime:moment().format("HH:mm:ss"),
            tTime:moment().format("HH:mm:ss"), 
            selectedPlayerList:props.selectedPlayer,
            selectedPlayer:props.selectedPlayer,      
            searchplayerAlias:props.playersList,    
            playersList:props.playersList,         
            selectedBuss:props.selectedBuss,           
            fromTimeZoneDate:moment(new Date()).subtract(1,'days').format("YYYY-MM-DD HH:mm:ss"),


        }
    }

    componentWillReceiveProps(nextProps) {
        if(Object.keys(nextProps.playersList).length > 0){
            let selectedPlayer = []
            , playersList = []
            , sortList = []
            nextProps.playersList.map((player) => {
                if (nextProps.selectedPlayer.indexOf(player.alias) != -1)
                    selectedPlayer.push(player)
                else
                    playersList.push(player)
            })
            sortList = _.orderBy(selectedPlayer, [player => player.alias && player.alias.toLowerCase()], ['desc'])
            sortList.map((plyr) => {
                playersList.unshift(plyr)
            })
            this.setState({ playersList: playersList })
        }
            this.setState({
            selectedPlayerList: nextProps.playersList.map(function(id) {return id.alias}),
            selectedPlayer:nextProps.selectedPlayer,      
            searchplayerAlias:nextProps.playersList,    
               
            selectedBuss:nextProps.selectedBuss, 
        })
    }
   
    handleClose = () =>{
        if(this.state.selectedPlayer.length === 0)
            this.setState({selectedPlayer: this.state.selectedPlayerList});
        this.setState({open: false});
    }

    handleOpen () {
        this.setState({loading: false})
        this.setState({open: true});
    }

    handleCloseSearch = () => {
        let selectedPlayer = []
            , playersList = []
            , sortList = []
        this.props.playersList.map((player) => {
            if (this.state.selectedPlayer.indexOf(player.alias) != -1)
                selectedPlayer.push(player)
            else
                playersList.push(player)
        })
        sortList = _.orderBy(selectedPlayer, [player => player.alias.toLowerCase()], ['desc'])
        sortList.map((plyr) => {
            playersList.unshift(plyr)
        })
        this.setState({ playersList: playersList })
        this.setState({ openSearch: false });
        this.state.playerAlias = this.state.searchplayerAlias
        this.forceUpdate()
    }

    openFromDateCalender = () => {
        this.refs.FromDatePicker.openDialog()
    }

    handleFromDate = (event, date) => {
        this.setState({ timeValue: "Select"});
        if(this.state.shiftValue!="Select"){
            date=moment(date).format("YYYY-MM-DD")+' '+this.state.fTime;
            this.setState({
              fromDate: date,
              fromTimeZoneDate:date
            })
        }
        else{
            date=moment(date).format("YYYY-MM-DD");
            this.setState({fromDate: date})
            this.refs.FromTimePicker.openDialog()
        }
    }

    handleFromTime = (event, time) =>{
        if(event){
            if(this.state.nightShift) {
                time=moment(new Date()).subtract(1,'days').format("YYYY-MM-DD ")+' '+event
                this.state.nightShift=false
            }
            else 
                time=moment().format("YYYY-MM-DD")+' '+event
        }
        else{
            this.state.fTime=moment(time).format("HH:mm:ss");
            time=this.state.fromDate+' '+this.state.fTime
        }
        this.state.fromDate= time,
        this.state.fromTimeZoneDate=time
       
        
        this.forceUpdate()
    }

    openToDateCalender = () =>{
        this.refs.ToDatePicker.openDialog()
    }
 
    handleToTime = (event, time) =>{
        if(event) time=moment().format("YYYY-MM-DD")+' '+event
        else{
           this.state.tTime=moment(time).format("HH:mm:ss");
           time=this.state.toDate+' '+this.state.tTime
        }
        this.setState({
           toDate: time,
           toTimeZoneDate:time
        })

        if(this.state.shiftValue=="NightShift"){
           var temp=this.state.fTime
           this.state.fTime=this.state.tTime
           this.state.tTime=temp
        }
    }

    handleToDate = (event, date) =>{
        this.setState({ timeValue: "Select"});
        if(this.state.shiftValue!="Select"){
            date=moment(date).format("YYYY-MM-DD")+' '+this.state.tTime;
            this.setState({
                toDate: date,
                toTimeZoneDate:date
            })
        }
        else{
           date=moment(date).format("YYYY-MM-DD");
           this.state.toDate=date
           this.setState({toDate:date})
           this.refs.ToTimePicker.openDialog()
        }
    }

    handleShift = (event) =>{
        this.setState({
          timeValue:"Select",
          shiftValue:event.target.value,
          timeZonevalue:"Select"
        })
        switch (event.target.value) {
            case 'Night Shift':
                this.state.fTime= "20:00:00",
                this.state.tTime= "04:00:00"
                this.state.nightShift=true
                this.state.shift="NightShift"
                this.handleFromTime(this.state.fTime)
                this.handleToTime(this.state.tTime)
               //  this.setShiftTimeOnZone()
                break;
            case 'Day Shift':
                this.state.fTime= "12:00:00",
                this.state.tTime= "20:00:00"
                this.state.shift="DayShift"
                this.handleFromTime(this.state.fTime)
                this.handleToTime(this.state.tTime)
               //  this.setShiftTimeOnZone()
                break;
            case 'Morning Shift':
                  this.state.fTime= "04:00:00",
                  this.state.tTime= "12:00:00"
                  this.state.shift="MorningShift"
                  this.handleFromTime(this.state.fTime)
                  this.handleToTime(this.state.tTime)
                 //  this.setShiftTimeOnZone()
                  break;
            case 'Select':
                  this.state.fromDate=moment().subtract(1,'days').format("YYYY-MM-DD HH:mm:ss"),
                  this.state.fromTimeZoneDate= this.state.fromDate
                  this.state.fromDate=this.state.fromDate
                  this.state.shift="Select"
                  break;
        }
        this.forceUpdate()
    }

    handleTime = (event,index,value) => {
        this.state.timeValue = value
        this.state.shift = 'Select'
        this.state.shiftValue = 'Select'
        this.state.timeZonevalue = 'Select'
        var selectedTime=moment(this.state.todaysDate).subtract(value.substring(0, value.indexOf(" ")),value.substring(value.indexOf("") +3)).format("YYYY-MM-DD HH:mm:ss");
        this.state.fromDate= selectedTime,
        this.state.toDate=moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        this.state.fromTimeZoneDate=selectedTime,
        this.state.toTimeZoneDate=moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
        this.setState({loading: true})
        this.forceUpdate()
        this.props.callApi(this.state.fromDate,this.state.toDate,this.state.shift)
    }

    changeDate = () => {
        if(this.state.selectedPlayer.length == 0){
            this.setState({open:true})
            this.setState({msg:'Please Select Atleast One Player....'})
        }
        this.state.activePage=1
        this.state.offset=0
        this.setState({loading: true})
        var timeZone=this.state.timeZone
        if(timeZone=='Coordinated Universal Time')timeZone=moment.tz.guess()
        // var fromDate=moment(this.state.fromTimeZoneDate).tz(timeZone).format("YYYY-MM-DD HH:mm:ss")
        // var toDate=moment(this.state.toTimeZoneDate).tz(timeZone).format("YYYY-MM-DD HH:mm:ss")
        // this.setState({
        //   fromDate:fromDate,
        //   toDate:toDate
        // })
        var compWithToday=this.compare(this.state.fromDate, this.state.todaysDate);
        var compWithToDate=this.compare(this.state.fromDate, this.state.toDate);
        if(compWithToday==1 && this.state.shift === 'Select'){
          this.state.msg="From Date Should be less than or equal to todays date"
          this.handleOpen();
        }
        else if(compWithToDate==1 && this.state.shift === 'Select'){
          this.state.msg="From Date should be less than To date"
          this.handleOpen();
        }
        else 
            this.props.callApi(this.state.fromDate,this.state.toDate,this.state.fTime,this.state.tTime,this.state.shift,this.state.selectedPlayer)
    }

    
    compare = (fromDate, toDate) => {
        var fromDate = moment(fromDate,"YYYY-MM-DD HH:mm:ss");
        var toDate = moment(toDate,"YYYY-MM-DD HH:mm:ss");
        if (fromDate > toDate){
        return 1;
        }
        else if (fromDate < toDate){
        return -1;
        }
        else {
        return 0;
        }
    }

    handleOpenSearch = () =>{
        this.setState({
          loading: false,
          openSearch: true
        })
    }

    filterList = (event) => {
        if(event.target.value.trim() == '')
        this.setState({playersList : this.props.playersList})
        else{
            var updatedList = this.props.playersList;
            updatedList = updatedList.filter(function(item){
              return item.alias.toLowerCase().search(event.target.value.trim().toLowerCase()) !== -1;
            });
            this.setState({playersList: updatedList});
        }
    }
    

    onPlayerChange = (alias,selectAllPlayer) => {
        if(alias == ''){
            if(selectAllPlayer){
                this.setState({
                    selectedPlayer:[],
                    selectAllPlayer:false
                })
            }
            else{
                this.state.selectedPlayer = this.state.selectedPlayerList
                this.state.selectAllPlayer = true
                this.forceUpdate()
            }
        }
        else{
            let index = this.state.selectedPlayer.indexOf(alias)
            if(index!=-1){
            this.state.selectedPlayer.splice(index, 1);
            this.forceUpdate()
            }
            else{
            this.state.selectedPlayer.push(alias)
            this.forceUpdate()
            }
        }
    }

    render(){
        const actions = [<FlatButton label="OK" primary={true} onTouchTap={this.handleClose}/> ]
        const actionsSearch = [<FlatButton  label="Close"  primary={true}    onTouchTap={this.handleCloseSearch} />  ]
        return(
            <div>
         
                <div>
                    <Dialog actions={actions}  modal={false}  open={this.state.open} onRequestClose={this.handleClose} >
                        {this.state.msg}
                    </Dialog>
                </div>
                
                <form>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                        {/* <Label>From Date</Label>
                        <Input className="fromdate" type="date" data-e2e="fromDate" name="date" id="exampleDate" placeholder="date placeholder" onChange={this.handleFromDate}/> */}
                            <TextField floatingLabelText="From Date:" onTouchTap={this.openFromDateCalender} value={this.state.fromDate}    />
                            <DatePicker data-e2e="fromDate" ref="FromDatePicker" onChange={this.handleFromDate}  id="fromDate" style={{display:"none"}} />
                            <TimePicker ref="FromTimePicker" onDismiss={() =>this.onTimerCancel(1)} onChange={this.handleFromTime} id="fromTime" style={{display:"none"}}/>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                        {/* <Label>To Date</Label>
                        <Input className="todate" type="date" data-e2e="toDate" name="date" id="exampleDate" placeholder="date placeholder" onChange={this.handleToDate}/> */}
                            <TextField floatingLabelText="To Date" onTouchTap={this.openToDateCalender} value={this.state.toDate}    />
                            <DatePicker data-e2e="toDate" ref="ToDatePicker" onChange={this.handleToDate} id="toDate" style={{display:"none"}}/>
                            <TimePicker ref="ToTimePicker" onChange={this.handleToTime} onDismiss={() =>this.onTimerCancel(2)}  id="toTime" style={{display:"none"}}/>
                        </div>
                        <div  className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                        Shift
                        <select className="selectshift" onChange={(e)=>this.handleShift(e)} id="shift" data-e2e="Shift">
                            <option value='Select'>Select</option>
                            <option value='Day Shift'>Day Shift</option>
                            <option value='Night Shift'>Night Shift</option>
                            <option value='Morning Shift'>Morning Shift</option>
                        </select>
                            {/* <SelectField data-e2e="Shift" floatingLabelText="Shift"  value={this.state.shiftValue} onChange={this.handleShift} id="shift"    >
                            <MenuItem value='Select' primaryText="Select" />
                            <MenuItem value='DayShift' primaryText="Day Shift" />
                            <MenuItem value='NightShift' primaryText="Night Shift" />
                            <MenuItem value='MorningShift' primaryText="Morning Shift" />
                            </SelectField> */}
                        </div>
                        <div  className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                        Period
                        <select className="selectperiod" onChange={this.handleTime} id="shift" data-e2e="Period">
                            <option value='Select'>Select</option>
                            <option value='Last 15 minutes'>Last 15 minutes</option>
                            <option value='Last Hour'>Last Hour</option>
                            <option value='Last 4 Hour'>Last 4 Hour</option>
                            <option value='Last 6 Hour'>Last 6 Hour</option>
                            <option value='Last 8 Hour'>Last 8 Hour</option>
                            <option value='Last 10 Hour'>Last 10 Hour</option>
                            <option value='Last 12 Hour'>Last 12 Hour</option>
                            <option value='Last 18 Hour'>Last 18 Hour</option>
                            <option value='Last 24 Hour'>Last 24 Hour</option>
                        </select>
                            {/* <SelectField data-e2e="Period" floatingLabelText="Period"  value={this.state.timeValue} onChange={this.handleTime} >
                                <MenuItem value='Select' primaryText="Select" disabled/>
                                <MenuItem value='15 minutes' primaryText="Last 15 minutes" />
                                <MenuItem value='01 hours' primaryText="Last Hour" />
                                <MenuItem value='04 hours' primaryText="Last 4 Hour" />
                                <MenuItem value='06 hours' primaryText="Last 6 Hour" />
                                <MenuItem value='08 hours' primaryText="Last 8 Hour" />
                                <MenuItem value='10 hours' primaryText="Last 10 Hour" />
                                <MenuItem value='12 hours' primaryText="Last 12 Hour" />
                                <MenuItem value='18 hours' primaryText="Last 18 Hour" />
                                <MenuItem value='24 hours' primaryText="Last 24 Hour" />
                            </SelectField> */}
                        </div>
                    </div>
                    <div className="row">
                        {this.state.access.indexOf('SYS_ADMIN') !=-1 ||  this.state.access.indexOf('BUSINESS_OWNER') !=-1
                            ?
                            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <SelectField
                                floatingLabelText="Business"
                                value={this.state.selectedBuss}
                                style={{textAlign: 'left'}}
                                onChange = {this.props.onBussChange}
                                multiple={true}
                                >
                                    <MenuItem value='All' primaryText='All' />
                                    { this.props.businessList.map((item, key) => {
                                        return (
                                            <MenuItem key={key} insetChildren={true} checked={this.state.selectedBuss && this.state.selectedBuss.indexOf(item._id) > -1} value={item._id} primaryText={item.business_name} />
                                        )
                                        })
                                    
                                    }
                                </SelectField>
                            </div>
                            :null}
                            {this.state.access.indexOf('SYS_ADMIN') !=-1  || this.state.access.indexOf('BUSINESS_OWNER') !=-1 || this.state.access.indexOf('SHIFT_MANAGER') !=-1
                                ?
                                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                    <SelectField
                                    floatingLabelText="Coach"
                                    value={this.props.selectedCoach}
                                    style={{textAlign: 'left',verticalAlign: 'bottom'}}
                                    onChange = {this.props.onCoachChange}
                                    multiple={true}
                                    >
                                        <MenuItem value='All' primaryText='All' />
                                        {
                                            this.props.coachList.map((item, key) => {
                                            return (
                                                <MenuItem insetChildren={true} checked={this.state.selectedCoach && this.state.selectedCoach.indexOf(item._id) > -1} value={item._id} primaryText={item.first_name + " " + item.last_name} />
                                            )
                                            })
                                        }
                                    </SelectField>
                                </div>
                                :null}
                            {this.state.access.indexOf('SYS_ADMIN') !=-1  || this.state.access.indexOf('SHIFT_MANAGER') !=-1 || this.state.access.indexOf('BUSINESS_OWNER') !=-1 || this.state.access.indexOf('COACH') !=-1
                                ?
                                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                    <TextField
                                        floatingLabelText="Player"
                                        onTouchTap={() =>  this.handleOpenSearch()}
                                        value={this.state.selectedPlayer}
                                        readOnly
                                        />
                                    <MediaQuery maxWidth={760}>
                                        {(matches) => {
                                            if (matches) {
                                                return (
                                                    <Dialog  contentStyle={{width:'100%', maxWidth: 'none'}} modal={false}  open={this.state.openSearch}  onRequestClose={this.handleCloseSearch} autoScrollBodyContent={true} actions={actionsSearch}>
                                                        <TextField floatingLabelText="alias" hintText="Search by alias" style={{width:'200px',marginBottom:'20px'}}  onChange={this.filterList}/>
                                                            <div style={{cursor:'pointer',  display:'inline-flex'}}  onTouchTap = {() =>this.onPlayerChange('',this.state.selectAllPlayer)}>
                                                                <input type="checkbox"  style={{cursor:'pointer',marginRight:'20px',height:'20px',width:'15px'}} checked={this.state.selectAllPlayer}/>
                                                                <label style={{cursor:'pointer'}} >Select All</label>
                                                            </div>
                                                            {this.state.playersList.map((item, key) => {
                                                                return (
                                                                <div key={key}>
                                                                    <div style={{cursor:'pointer',  display:'inline-flex'}} onTouchTap = {() =>this.onPlayerChange(item.alias)}>
                                                                        <input type="checkbox"  style={{cursor:'pointer',marginRight:'20px',height:'20px',width:'15px'}} checked={this.state.selectedPlayer && this.state.selectedPlayer.indexOf(item.alias) > -1}/>
                                                                        <label style={{cursor:'pointer'}} >{item.alias}</label>
                                                                    </div>
                                                                <br/>
                                                                </div>
                                                            )
                                                            })}
                                                    </Dialog>
                                                )
                                            
                                            } else {
                                                return(
                                                    <Dialog contentStyle={{width:'20%'}}  modal={false}  open={this.state.openSearch}  onRequestClose={this.handleCloseSearch} autoScrollBodyContent={true}  actions={actionsSearch}>
                                                        <TextField  hintText="Search by alias" style={{width:'200px',marginBottom:'20px'}}  onChange={this.filterList}/>
                                                            <div style={{cursor:'pointer',  display:'inline-flex'}} onTouchTap = {() =>this.onPlayerChange('',this.state.selectAllPlayer)}>
                                                                <input type="checkbox"  style={{cursor:'pointer',marginRight:'20px',height:'20px',width:'15px'}} checked={this.state.selectAllPlayer}/>
                                                                <label style={{cursor:'pointer'}} >Select All</label>
                                                            </div>
                                                        {Object.keys(this.state.playersList).length >0 &&
                                                            this.state.playersList.map((item, key) => {
                                                                return (
                                                                    <div key={key}>
                                                                        <div style={{ cursor: 'pointer', display: 'inline-flex' }} onTouchTap={() => this.onPlayerChange(item.alias)}>
                                                                            <input type="checkbox" style={{ cursor: 'pointer', marginRight: '20px', height: '20px', width: '15px' }} checked={this.state.selectedPlayer && this.state.selectedPlayer.indexOf(item.alias) > -1} />
                                                                            <label style={{ cursor: 'pointer' }} >{item.alias}</label>
                                                                        </div>
                                                                        <br />
                                                                    </div>
                                                                    )
                                                                })}
                                                    </Dialog>
                                                )
                                           
                                            }
                                        }}
                                    </MediaQuery>
                                </div>
                                :null}
                                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3" style={{paddingTop:"2%"}} >
                                    <RaisedButton data-e2e="search" disabled={!this.props.fromDate}   label="Search" onClick={this.changeDate} primary={true}/>
                                </div>  
                    </div>  
                    </form>
               
            </div>
        )

    }
   
}

export default PokerwatchFilters;


/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchComp/PokerwatchFilter.js
 **/